import { render } from "./HowItWorksBoxesComponent.vue?vue&type=template&id=ed88cfba"
import script from "./HowItWorksBoxesComponent.vue?vue&type=script&lang=js"
export * from "./HowItWorksBoxesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__